export const buildVoiceGenerationPayload = ({
  projectId,
  projectName,
  voiceDescription,
  text,
  autoGenerateText,
  loudness,
  seed,
  guidanceScale,
  streamPreviews,
  remixingSessionId,
  remixingSessionIterationId,
  promptStrength,
  characterVoices,
}) => {
  const legacyCharacterVoices = characterVoices.map((characterVoice) => ({
    speaker_id: characterVoice.speakerId,
    emotion: characterVoice.emotion,
  }));

  return {
    projectId,
    projectName,
    voiceDescription,
    text,
    autoGenerateText,
    loudness,
    seed,
    guidanceScale,
    streamPreviews,
    remixingSessionId,
    remixingSessionIterationId,
    promptStrength,
    characterVoices,
    // Deprecated aliases allow the frontend to deploy before the orchestrator.
    project_id: projectId,
    project_name: projectName,
    voice_description: voiceDescription,
    auto_generate_text: autoGenerateText,
    guidance_scale: guidanceScale,
    stream_previews: streamPreviews,
    remixing_session_id: remixingSessionId,
    remixing_session_iteration_id: remixingSessionIterationId,
    prompt_strength: promptStrength,
    character_voices: legacyCharacterVoices,
  };
};
